import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import axios from 'axios';
import React, { Fragment, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setPDFData } from '../../../../../components/hooks/printPdf/pdfData';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import DialogCancel from '../../../../../components/utils/dialogCancel/dialogCancel';

const CustomerInfo = ({data,setData,postData,setPostData ,docName ,setDocName}) => {
const [companyData , setCompanyData] = useState(null)
const[open,setOpen] = useState(false)
  const [dialogClose, setDialogClose] = useState(false);

const [isSubmitting, setIsSubmitting] = useState(false); 
const dispatch = useDispatch()
const navigate = useNavigate()

  let totalAmt=0
  totalAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.totalAmt), 0);
  let gstAmt=0
  gstAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.gstAmt), 0);
  let cessAmt=0
  cessAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.cessAmt), 0);
  let netTotal = 0
  // netTotal = parseFloat(totalAmt + gstAmt + cessAmt).toFixed(0)
  netTotal = parseFloat(totalAmt + gstAmt ).toFixed(0)


const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

  const convertNumber = (num) => {
    if (num === 0) return 'Zero';

    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };
  const onClickCancel = () => {
    setDialogClose(false);
  };
  const onClickExit = () => {
    navigate("/");
  };
  // console.log(paymentDetails)
  const handleExit = () => {
    setDialogClose(true);
  };

  const Design = ({ title, value }) => (
    <div className="flex items-center">
      <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
        {title}
      </Typography>
      <Typography variant="h6" textAlign="right" sx={{ fontWeight: 600, width: "100%", padding: 0.5, }}>
        {parseFloat(value).toFixed(0)}
      </Typography>
    </div>
  );

  // function handleSubmit(){
  //   if(postData.partycode === "" ){
  //     dispatch(setSnackbar(true , "error" , "Please select Supplier Name"))
  //   }else if(postData.partydc === ""){
  //     dispatch(setSnackbar(true , "error" , "Please fill Po No and Party Dc / Inv no"))
  //   }else if(postData.purchase_details.length === 0){
  //     dispatch(setSnackbar(true , "error" , "Please fill table & Click enter to save"))
  //   }else{
  //     // generatePDF()
  //     console.log(tableData,'CompanyData',data)
  //     axios.post(`/v1/purchase`,postData)
  //   .then((res) => {
  //     dispatch(setSnackbar(true,'success', 'Bill saved successfully!'))
  //     fetchBill()
  //   })
  // .catch((err) => {
  //   dispatch(setSnackbar(true , "error" , err.response.data.errors[0].message))
  // })
  //   }
  // }
  const handleSubmit = async () => {
    if (isSubmitting) return; // Prevent double click
    setIsSubmitting(true); // Set the state to true to disable the button
    console.log('Submission started');
    if (postData.partycode === "") {
      dispatch(setSnackbar(true, "error", "Please select Supplier Name"));
      setIsSubmitting(false); // Re-enable the button if there's an error
    } else if (postData.partydc === "") {
      dispatch(setSnackbar(true, "error", "Please fill Po No and Party Dc / Inv no"));
      setIsSubmitting(false); // Re-enable the button if there's an error
    } else if (postData.purchase_details.length === 0) {
      dispatch(setSnackbar(true, "error", "Please fill table & Click enter to save"));
      setIsSubmitting(false); // Re-enable the button if there's an error
    } else {
      try {
        await axios.post(`/v1/purchase`, postData);
        dispatch(setSnackbar(true, 'success', 'Bill saved successfully!'));
        fetchBill();
      } catch (err) {
        dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
      } finally {
        setIsSubmitting(false); // Re-enable the button after the submission is complete
        console.log('Submission finished');
      }
    }
  };
  console.log(isSubmitting)
const tableData = data.map(val=>({
  pro_name: val.pro_name,
  hsn:val.hsn,
  sale_rate:val.rate1,
  qty:val.qty,
  disc1:val.disc1,
  cgstPerc:val.gst1,
  cgstAmnt : val.gstAmt,
  totalAmt:val.totalAmt

}))
console.log(tableData.reduce((acc, rowTotal) => acc + rowTotal.totalAmt, 0),'vanthudu')
const TotalData = {
  cess_amt:cessAmt,
  sub_total: totalAmt,
  gst:gstAmt,
  totalAmount:parseFloat(Math.round(netTotal)).toFixed(0),
  roundOff:(parseFloat(Math.round(netTotal).toFixed(0) -netTotal).toFixed(0)),
  totalText : convertNumber(Math.round(netTotal)),
}

console.log(TotalData, tableData)

function fetchBill(){
  axios.post(`/v1/purchase/getall`,{"docno":docName})
  .then((res) => {
    console.log(res);
      dispatch(setPDFData({
        tableData:tableData,
        TotalData:TotalData,
        companyInfo:res.data,  
        totalText : convertNumber(Math.round(netTotal)),
        title : "Purchase Invoice"
      }))
      const name = `BillNo_${docName}`
     navigate(`/invoice/${name}`)  
    
  })
    
    .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.error))})
}
const handleDelete = () => {
  setData([])
  dispatch(setSnackbar(true , 'success' , "Table value deleted successfully"))
}

  // function generatePDF(){
  //   dispatch(setPDFData({
  //     tableData:tableData,
  //     TotalData:TotalData,
  //     companyInfo:companyData,  
  //   }))
  //   const name = 'BillNo_'
  //  navigate(`/invoice/${name}`)  
  // };
  
  useEffect(() => {
    setPostData((prevState)=>({...prevState, amount: Math.round(parseFloat(netTotal)), subtotal_amount:totalAmt ,gst_amt:gstAmt,cess_amt:cessAmt,roff:(Math.round(netTotal).toFixed(0) -netTotal), freight_charges:0, other_charges:0,}))
  },[data])
  console.log(postData)
  return (
    <Fragment>

        <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }}>Total</Typography>
        <div className="flex p-1">
              <Typography 
              textAlign="right" sx={{  paddingRight: 0.4, fontWeight: 600, fontSize: 36, width:'100%'}}          >
                {Math.round(parseFloat(totalAmt + gstAmt )).toFixed(0)}
              </Typography>
            </div>
            <div className="my-2">
          <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }} > Summary </Typography>
          <Design title="Sub Total" value={totalAmt} />
          <Design title="GST Amt" value={gstAmt}/>
          {/* <Design title="Cess" value={cessAmt}/> */}
          <Design title="Round Off" value={( Math.round(netTotal).toFixed(0) -netTotal )}/>
          <Design title="Net Total" value={Math.round(netTotal)}/>
        </div>
        <Stack  >
        {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="outlined" onClick={handleDelete}>Delete</Button> */}
       {/* <Button size="small" sx={{margin:1}} startIcon={<Print/>} variant="outlined" onClick={()=>generatePDF()}>Print</Button> */}
        <Button size="small" sx={{margin:1}} startIcon={<NoteAdd/>} variant="outlined" onClick={()=>window.location.reload()}>New</Button>
        <Button size="small" sx={{margin:1}} startIcon={<Save/>} variant="outlined" onClick={handleSubmit} disabled={isSubmitting} >Save</Button>
        <Button size="small" sx={{margin:1}} startIcon={<ExitToApp />} variant="outlined" onClick={handleExit}>Exit</Button>
        {/* <Button size="small" sx={{margin:1}} startIcon={<ExitToApp />} variant="outlined" onClick={() => navigate(-1)}>Exit</Button> */}
        </Stack>
        <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
    </Fragment>
  )
}

export default memo(CustomerInfo)